import { useDownloadAgreementPdf } from '~/hooks/relationship/useDownloadAgreementPdf';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel } from '~/models';
export function useClientFlowPdfDownload() {
    const { downloadAgreementPdf } = useDownloadAgreementPdf();
    const { t: texts } = useLocaleKeys('clientFlow.pdfToast');
    return {
        downloadPdf: (relationship)=>{
            const isAgreement = relationshipModel.isApproved(relationship);
            const clientName = relationshipModel.customerName(relationship);
            downloadAgreementPdf(relationshipModel.id(relationship), undefined, {
                ready: isAgreement ? texts.agreementReady({
                    clientName
                }) : texts.proposalReady({
                    clientName
                }),
                failed: isAgreement ? texts.agreementFailed({
                    clientName
                }) : texts.proposalFailed({
                    clientName
                })
            });
        }
    };
}
